export const logoSm: string[] = ['70 93', `
<svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px" y="0px" viewBox="0 0 193.48 287.4" xml:space="preserve">
<g>
<g>
  <path fill="#FFFFFF" d="M25.29,230.81c0-4.51,5.6-5.91,10.41-5.91c8.86,0,19.75,3.27,26.12,7.62V214.8
    c-7.62-3.73-16.94-6.37-27.51-6.37c-15.71,0-31.1,5.75-31.1,23.01c0,26.74,42.13,21.46,42.13,33.43c0,4.2-5.13,5.6-13.06,5.6
    c-9.02,0-20.37-2.64-28.45-7.93v17.88c7.62,4.51,18.35,7,29.7,7c17.88,0,33.89-5.44,33.89-23.01
    C67.43,237.02,25.29,243.24,25.29,230.81z"/>
  <path fill="#FFFFFF" d="M165.65,208.42c-10.26,0-18.66,4.97-24.88,11.04c-4.35-6.38-11.66-11.04-22.85-11.04
    c-11.35,0-19.9,6.22-23.79,10.88v-8.71H75.01v74.63h21.61v-49.13c3.58-4.66,9.49-9.01,16.01-9.01c6.84,0,11.66,4.51,11.66,12.28
    v45.87h21.45c0,0-0.04-50.81-0.03-50.82c3.57-3.98,8.8-7.32,14.64-7.32c6.84,0,11.66,4.51,11.66,12.28v45.87h21.45v-47.26
    C193.48,224.74,186.64,208.42,165.65,208.42z"/>
</g>
<g>
  <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="13.7227" y1="48.73" x2="92.9654" y2="127.9726">
    <stop  offset="0.55" style="stop-color:#ED1B2F"/>
    <stop  offset="0.6537" style="stop-color:#DD202F"/>
    <stop  offset="0.8679" style="stop-color:#B82931"/>
    <stop  offset="1" style="stop-color:#9E2D33"/>
  </linearGradient>
  <path fill="url(#SVGID_1_)" d="M79.17,141.76l0-126.05c0-6.5,5.27-11.77,11.76-11.77L68.28,3.92c-6.47,0-12.34,2.61-16.59,6.84
    L20.52,41.93c-4.26,4.26-6.89,10.15-6.89,16.64l0.02,108.16c0,5.21,4.23,9.44,9.44,9.44h16.8c3.25,0,6.19-1.32,8.32-3.45
    L79.17,141.76z"/>
  <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="39.8896" y1="133.1118" x2="174.1001" y2="133.1118">
    <stop  offset="0.55" style="stop-color:#ED1B2F"/>
    <stop  offset="0.95" style="stop-color:#9E2D33"/>
  </linearGradient>
  <path fill="url(#SVGID_2_)" d="M130.86,90.05l39.79,39.8c4.6,4.59,4.6,12.04,0,16.64l-22.77,22.8
    c-4.26,4.25-10.14,6.88-16.63,6.88l-91.36,0.01c3.25,0,6.19-1.32,8.32-3.45L130.86,90.05z"/>
  <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="79.1621" y1="75.2151" x2="185.8877" y2="75.2151">
    <stop  offset="0" style="stop-color:#9E2D33"/>
    <stop  offset="0.0729" style="stop-color:#A62C32"/>
    <stop  offset="0.2022" style="stop-color:#BA2831"/>
    <stop  offset="0.3717" style="stop-color:#DB202F"/>
    <stop  offset="0.45" style="stop-color:#ED1B2F"/>
  </linearGradient>
  <path fill="url(#SVGID_3_)" d="M185.89,121.53c0,6.51-2.64,12.39-6.9,16.65l-8.34,8.31c4.6-4.6,4.6-12.05,0-16.64l-91.49-91.5
    V15.71c0-6.5,5.27-11.77,11.76-11.77h85.52c5.21,0,9.44,4.23,9.44,9.44V121.53z"/>
</g>
</g>
</svg>
`]
